import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { ShiftRegisterFilters } from '@/api/models';
import type { GetShiftRegisterResponse } from '@/api/handlers/resources/shifts';
import type { ApiResponse } from '@/api/handlers/responses';
import { ShiftsQueryKeys } from './shiftsQueryKeys';

const STALE_TIME_MS = 30_000;

/**
 * A page of the shift register.
 *
 * `enabled` is the caller's, the pattern every back-office query here follows:
 * access is derived from the session before fetching, because a raw 403 tells
 * the user nothing they can act on — and these endpoints refuse a PIN/kiosk
 * token whatever role it carries.
 */
export const useShiftRegisterQuery = (
    filters: ShiftRegisterFilters,
    enabled: boolean,
) => {
    const { apiClient } = useApi();

    return useQuery<ApiResponse<GetShiftRegisterResponse>>({
        queryKey: ShiftsQueryKeys.register(filters),
        queryFn: () => apiClient.shifts.getRegister(filters),
        enabled,
        staleTime: STALE_TIME_MS,
        placeholderData: keepPreviousData,
    });
};
